var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("StatusBar", { attrs: { params: this.$route.query.params } }),
      _c("SearchBar", {
        attrs: { show: _vm.showSearchBar },
        on: {
          showSearchBar: function ($event) {
            _vm.showSearchBar = !_vm.showSearchBar
          },
          search: function ($event) {
            ;(_vm.currentPage = 1), _vm.getResume()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "searchItem",
            fn: function () {
              return [
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    clearable: "",
                    placeholder: "關鍵字（姓名、Email、連絡電話）",
                  },
                  model: {
                    value: _vm.searchCondition.Keyword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "Keyword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.Keyword",
                  },
                }),
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: { clearable: "", placeholder: "學校名稱" },
                  model: {
                    value: _vm.searchCondition.SchoolKeyWord,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "SchoolKeyWord",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.SchoolKeyWord",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      clearable: "",
                      placeholder: "科系類別",
                    },
                    model: {
                      value: _vm.searchCondition.Majors,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Majors", $$v)
                      },
                      expression: "searchCondition.Majors",
                    },
                  },
                  _vm._l(_vm.majorOptions, function (major) {
                    return _c("el-option", {
                      key: major.Guid,
                      attrs: { label: major.Name, value: major.Name },
                    })
                  }),
                  1
                ),
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: { clearable: "", placeholder: "科系名稱" },
                  model: {
                    value: _vm.searchCondition.MajorNameKeyword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "MajorNameKeyword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.MajorNameKeyword",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      clearable: "",
                      placeholder: "學歷等級",
                    },
                    model: {
                      value: _vm.searchCondition.EducationDegrees,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "EducationDegrees", $$v)
                      },
                      expression: "searchCondition.EducationDegrees",
                    },
                  },
                  _vm._l(
                    _vm.educationDegreeOptions,
                    function (educationDegree) {
                      return _c("el-option", {
                        key: educationDegree.Guid,
                        attrs: {
                          label: educationDegree.Name,
                          value: educationDegree.Name,
                        },
                      })
                    }
                  ),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: { clearable: "", placeholder: "外籍在台" },
                    model: {
                      value: _vm.searchCondition.Foreigner,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Foreigner", $$v)
                      },
                      expression: "searchCondition.Foreigner",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "是", value: true } }),
                    _c("el-option", { attrs: { label: "否", value: false } }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: { clearable: "", placeholder: "領有身心障礙手冊" },
                    model: {
                      value: _vm.searchCondition.HasDisabilityCard,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "HasDisabilityCard", $$v)
                      },
                      expression: "searchCondition.HasDisabilityCard",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "是", value: true } }),
                    _c("el-option", { attrs: { label: "否", value: false } }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      clearable: "",
                      placeholder: "通訊地區",
                    },
                    model: {
                      value: _vm.searchCondition.ContactDistricts,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "ContactDistricts", $$v)
                      },
                      expression: "searchCondition.ContactDistricts",
                    },
                  },
                  _vm._l(_vm.districtOptions, function (district) {
                    return _c("el-option", {
                      key: district.Guid,
                      attrs: { label: district.Name, value: district.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      clearable: "",
                      placeholder: "戶籍地區",
                    },
                    model: {
                      value: _vm.searchCondition.Districts,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Districts", $$v)
                      },
                      expression: "searchCondition.Districts",
                    },
                  },
                  _vm._l(_vm.districtOptions, function (district) {
                    return _c("el-option", {
                      key: district.Guid,
                      attrs: { label: district.Name, value: district.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      clearable: "",
                      placeholder: "履歷來源",
                    },
                    model: {
                      value: _vm.searchCondition.MatchSource,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "MatchSource", $$v)
                      },
                      expression: "searchCondition.MatchSource",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "首頁主動應徵", value: "首頁主動應徵" },
                    }),
                    _c("el-option", {
                      attrs: { label: "ERecruiter", value: "ERecruiter" },
                    }),
                    _c("el-option", {
                      attrs: { label: "臨時到廠轉入", value: "臨時到廠轉入" },
                    }),
                    _c("el-option", {
                      attrs: { label: "人才庫轉入", value: "人才庫轉入" },
                    }),
                    _c("el-option", {
                      attrs: { label: "轉推薦轉入", value: "轉推薦轉入" },
                    }),
                    _c("el-option", {
                      attrs: { label: "後台1111匯入", value: "後台1111匯入" },
                    }),
                  ],
                  1
                ),
                _c("el-date-picker", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    type: "daterange",
                    clearable: "",
                    "range-separator": "-",
                    "start-placeholder": "履歷轉入日期(起)",
                    "end-placeholder": "履歷轉入日期(迄)",
                  },
                  model: {
                    value: _vm.matchDateRange,
                    callback: function ($$v) {
                      _vm.matchDateRange = $$v
                    },
                    expression: "matchDateRange",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      "collapse-tags": "",
                      placeholder: "應聘者狀態",
                    },
                    model: {
                      value: _vm.searchCondition.Status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Status", $$v)
                      },
                      expression: "searchCondition.Status",
                    },
                  },
                  _vm._l(_vm.candidateStatusOptions, function (status) {
                    return _c("el-option", {
                      key: status.key,
                      attrs: { label: status.value, value: status.key },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: { clearable: "", placeholder: "履歷狀態" },
                    model: {
                      value: _vm.searchCondition.IsExpire,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "IsExpire", $$v)
                      },
                      expression: "searchCondition.IsExpire",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "已過期", value: true },
                    }),
                    _c("el-option", {
                      attrs: { label: "未過期", value: false },
                    }),
                  ],
                  1
                ),
                _c("el-cascader", {
                  staticClass: "w-100",
                  attrs: {
                    clearable: "",
                    options: _vm.contactOptions,
                    props: { multiple: true },
                    "show-all-levels": true,
                    placeholder: "聯繫狀態",
                  },
                  model: {
                    value: _vm.searchCondition.ContactStatusGuids,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchCondition, "ContactStatusGuids", $$v)
                    },
                    expression: "searchCondition.ContactStatusGuids",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "tool-list" },
        [
          _c("span", { staticClass: "mr-2" }, [
            _vm._v("共計：" + _vm._s(_vm.totalPerson) + "人"),
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-info btn-sm tool-list-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.openCommonModal({ event: "upload" })
                },
              },
            },
            [_vm._v(" 匯入資料 ")]
          ),
          _vm.personList.length > 0
            ? _c("CardStyle", { on: { changeStyle: _vm.changeStyle } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: true, person: person },
                on: { updatePersonList: _vm.updatePersonList },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "note",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickResumeNote(props)
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: {
                                  name: "color-picker-outline",
                                  fill: "#000",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.InterviewResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [_vm._v("轉入職缺時間")]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$common.dateTimeFormatter(
                                        props.JobMatchCreateTime
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("應徵職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("學歷")]),
                              _c("pre", [
                                _vm._v(
                                  "                " +
                                    _vm._s(
                                      props.Education
                                        ? props.Education[0]
                                        : null
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th"),
                              _c("pre", [
                                _vm._v(
                                  "                " +
                                    _vm._s(
                                      props.Education
                                        ? props.Education[1]
                                        : null
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("經歷")]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.WorkExperience
                                        ? props.WorkExperience[0]
                                        : null
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th"),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.WorkExperience
                                        ? props.WorkExperience[1]
                                        : null
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("履歷來源")]),
                              _c("td", [_vm._v(_vm._s(props.Source))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("最後聯繫")]),
                              _c("pre", [
                                _vm._v(
                                  "                " +
                                    _vm._s(props.LatestContactRecord) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("最新應徵職缺")]),
                              _c("pre", [
                                _vm._v(
                                  "                " +
                                    _vm._s(props.LatestJobApply) +
                                    "／" +
                                    _vm._s(props.LatestStatus) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          props.InterviewResult === "尚未邀約" ||
                          props.InterviewResult === "複試"
                            ? _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.clickInterviewInvitation(props)
                                    },
                                  },
                                },
                                [_vm._v(" 面談邀約 ")]
                              )
                            : _vm._e(),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickContactInfo(props)
                                },
                              },
                            },
                            [_vm._v(" 聯繫資訊 ")]
                          ),
                          props.ResumeType === "DL" &&
                          props.InterviewResult === "尚未邀約" &&
                          _vm.$Permission.JobOpening.SpecialProcess.IsValid
                            ? _c(
                                "button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.createAppointmentForm(props)
                                    },
                                  },
                                },
                                [_vm._v(" 起任用單 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c("ResumeNoteModal", {
        attrs: { personData: _vm.interviewee },
        on: { getFactory: _vm.getFactory },
      }),
      _c("ResumeTagModal", { attrs: { ResumeId: _vm.ResumeId } }),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          totalPerson: _vm.totalPerson,
          selectedCardList: _vm.choosePersonList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openCommonModal({ event: "expire" })
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "clock-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("標記為過期")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openCommonModal({ event: "recover" })
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "undo-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("移除過期標記")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    staticStyle: { background: "red" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openCommonModal({ event: "remove" })
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "trash-2-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("履歷移除")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openCommonModal({ event: "factory" })
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "settings-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("維護廠別")]),
                  ],
                  1
                ),
                _c(
                  "a",
                  {
                    staticClass: "select-all-btn",
                    staticStyle: { "margin-right": "5px", color: "#000" },
                    attrs: { type: "button", href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.selectSearchResult.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" 查詢結果全選 ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("InterviewMailModal", {
        attrs: { personData: _vm.interviewee },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c("SearchResultAll", {
        attrs: { totalPerson: _vm.totalPerson },
        on: {
          closeActionBar: function ($event) {
            _vm.showActionBar = false
          },
          clearSelectCard: _vm.clearSelectCard,
          getResume: _vm.getResume,
        },
      }),
      _c("ContactInfoModal", { attrs: { personData: _vm.interviewee } }),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "commonModal",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c("ValidationObserver", {
                ref: "common",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(_vm._s(_vm.modalTitle)),
                              ]),
                              _vm.modalEvent === "upload"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "close",
                                      attrs: {
                                        type: "button",
                                        "data-dismiss": "modal",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "aria-hidden": "true" } },
                                        [_vm._v("×")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "modal-body",
                                style:
                                  _vm.modalEvent === "factory"
                                    ? { height: "330px" }
                                    : null,
                              },
                              [
                                _vm.modalEvent === "upload"
                                  ? _c("div", [
                                      _c("p", { staticClass: "form-group" }, [
                                        _c(
                                          "u",
                                          {
                                            staticStyle: {
                                              color: "midnightblue",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.$common.downloadResumeTemplate.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 點擊下載範例檔 ")]
                                        ),
                                      ]),
                                      _c("p", { staticClass: "form-group" }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v(
                                            "* 檔案限制：[檔名].xlsx、[檔名].xls"
                                          ),
                                        ]),
                                        _c("br"),
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("* 大小限制：10MB 以下"),
                                        ]),
                                        _c("br"),
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("* 上傳前請確認是否符合格式"),
                                        ]),
                                        _c("br"),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "from-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("檔案"),
                                          ]),
                                          _c(
                                            "el-upload",
                                            {
                                              ref: "upload",
                                              attrs: {
                                                action: "",
                                                accept: ".xls,.xlsx",
                                                "auto-upload": false,
                                                "show-file-list": false,
                                                "on-change": _vm.uploadFile,
                                                limit: 1,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                  },
                                                },
                                                [_vm._v("點擊上傳")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm.modalEvent === "expire"
                                  ? _c("p", [_vm._v("確定將履歷標記為過期？")])
                                  : _vm.modalEvent === "recover"
                                  ? _c("p", [_vm._v("確定移除履歷過期標記？")])
                                  : _vm.modalEvent === "remove"
                                  ? _c("p", [_vm._v("確定將履歷移除？")])
                                  : _c(
                                      "div",
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "廠別",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("multiselect", {
                                                      attrs: {
                                                        options:
                                                          _vm.factoryOptions,
                                                        multiple: "",
                                                        placeholder: "請選擇",
                                                        label: "Name",
                                                        "track-by": "Guid",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.chooseFactoryList,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.chooseFactoryList =
                                                            $$v
                                                        },
                                                        expression:
                                                          "chooseFactoryList",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.modalEvent !== "upload",
                                    expression: "modalEvent !== 'upload'",
                                  },
                                ],
                                staticClass: "modal-footer",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(_vm.saveModal)
                                      },
                                    },
                                  },
                                  [_vm._v(" 確認 ")]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.showInterviewRecord
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.detailCurrentPage = 1
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    name: "message-circle-outline",
                                    fill: "#FFF",
                                  },
                                }),
                                _vm._v(" 面談紀錄 "),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.showAppointmentRecord
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.detailCurrentPage = 2
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    name: "clipboard-outline",
                                    fill: "#FFF",
                                  },
                                }),
                                _vm._v(" 任用單 "),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                },
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$store.commit(
                                                      "OpenResumeCategoryModal",
                                                      true
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 分類 ")]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 1
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("面談紀錄")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("InterviewRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 2
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("任用單")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("AppointmentRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }